angular.module('aprima-core-ui').directive('apFormContainer', ['_', function (_) {
    'use strict';

    return {
        restrict: 'A',
        compile: function (element, attrs) {
			var containerDisabledExpression = attrs.apFormContainerDisabledExpression;
            
            if(containerDisabledExpression){
                _.forEach(element.find('button,input,select,textarea'), function(input){
                   input = $(input);
                   
                   if(!input.attr('ap-form-ignore-disabled')){
                       var elementExpression = input.attr('ng-disabled');
                       
                       if(elementExpression){
                           elementExpression += ' || (' + containerDisabledExpression + ')';
                       } 
                       else{
                           elementExpression = containerDisabledExpression;
                       }
                       
                       input.attr('ng-disabled', elementExpression);
                   }
                });
            }
        }
    };
}]);